/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetSkillSecurity = {
  option1?: GetSkillSecurityOption1 | undefined;
  option2?: GetSkillSecurityOption2 | undefined;
};

export type GetSkillRequest = {
  /**
   * The skill ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  GetSkillSecurityOption1$Outbound,
  GetSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getSkillSecurityOption1ToJSON(
  getSkillSecurityOption1: GetSkillSecurityOption1,
): string {
  return JSON.stringify(
    GetSkillSecurityOption1$outboundSchema.parse(getSkillSecurityOption1),
  );
}

/** @internal */
export type GetSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  GetSkillSecurityOption2$Outbound,
  GetSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getSkillSecurityOption2ToJSON(
  getSkillSecurityOption2: GetSkillSecurityOption2,
): string {
  return JSON.stringify(
    GetSkillSecurityOption2$outboundSchema.parse(getSkillSecurityOption2),
  );
}

/** @internal */
export type GetSkillSecurity$Outbound = {
  Option1?: GetSkillSecurityOption1$Outbound | undefined;
  Option2?: GetSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetSkillSecurity$outboundSchema: z.ZodMiniType<
  GetSkillSecurity$Outbound,
  GetSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(z.lazy(() => GetSkillSecurityOption1$outboundSchema)),
    option2: z.optional(z.lazy(() => GetSkillSecurityOption2$outboundSchema)),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getSkillSecurityToJSON(
  getSkillSecurity: GetSkillSecurity,
): string {
  return JSON.stringify(
    GetSkillSecurity$outboundSchema.parse(getSkillSecurity),
  );
}

/** @internal */
export type GetSkillRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetSkillRequest$outboundSchema: z.ZodMiniType<
  GetSkillRequest$Outbound,
  GetSkillRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function getSkillRequestToJSON(
  getSkillRequest: GetSkillRequest,
): string {
  return JSON.stringify(GetSkillRequest$outboundSchema.parse(getSkillRequest));
}
